import React from 'react';

import { translate } from '../../../../base/i18n';
import { footerSection } from '../styles';

/**
 * Footer Section for clickandpledge
 */
function FooterSection({ t }) {
    return (
        <p className = 'footer-securedby'>
            <span style = { footerSection.lockIcon }>&#x1F512; </span>
            <i>{t('clickandpledge.securedAndPoweredBy')}{' '} </i>
            <strong> Click & Pledge</strong>
        </p>
    );
}

export default translate(FooterSection);
